<template>
  <div class="avatar">
    <img
      :src="pathfinder.avatar"
      class="avatar"
      :style="withElementBackground"
    >
    <p
      class="name"
      v-if="!hideName"
    >{{ pathfinder.name }}</p>
  </div>

</template>

<style lang="scss">
  img.avatar {
    width: 100%;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.5))
      drop-shadow(0px -6px 16px rgba(80, 227, 194, 0.32));
  }
  .name {
    text-align: center;
    font-weight: bold;
  }
</style>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    name: "Avatar",
    props: ["pathfinder", "hideName"],
    computed: {
      ...mapGetters(["getElementBackground"]),
      withElementBackground() {
        const backgroundImage = this.getElementBackground(this.pathfinder);
        if (backgroundImage) {
          return {
            backgroundImage: backgroundImage,
            backgroundSize: "150%",
            backgroundPosition: "center"
          };
        } else {
          return {};
        }
      }
    }
  };
</script>
